import get from 'lodash/get'
import has from 'lodash/has'
import EventBus, { FRONTEND_PAGE_RENDERED } from '~/bus'
import ControlsSubHeader from '~/mixins/controls-sub-header'
import { getPageTitle } from '~/utils/framework'

export default {
  name: 'Page',
  layout: 'frontend',
  mixins: [
    ControlsSubHeader,
  ],
  head () {
    const head = {
      meta: [],
      title: this.pageTitle,
    }

    if (this.hasCustomPageDescription) {
      head.meta.push({
        hid: 'description',
        name: 'description',
        content: this.pageDescription,
      })
    }

    return head
  },
  computed: {
    baseUrl () {
      return process.env.BASE_URL
    },
    hasCustomPageDescription () {
      const locale = get(this.$i18n, 'locale')

      return has(this.$options, ['i18n', 'messages', locale, 'head', 'description'])
    },
    hasCustomPageTitle () {
      const locale = get(this.$i18n, 'locale')

      return has(this.$options, ['i18n', 'messages', locale, 'head', 'title'])
    },
    pageDescription () {
      return this.hasCustomPageDescription ? this.$t('head.description') : null
    },
    pageTitle () {
      return this.hasCustomPageTitle
        ? getPageTitle.call(this, this.$t('head.title'))
        : getPageTitle.call(this)
    },
    subheader () {
      const heading = this.$t('heading')

      return {
        heading: heading === 'heading' ? '' : heading,
        extraClasses: '',
      }
    },
  },
  mounted () {
    EventBus.$emit(FRONTEND_PAGE_RENDERED, { vm: this })
  },
}
